// Parser for /categories URL search params. `period` is a YYYY-MM key driving
// the per-period transaction-count and EUR-total columns (issue #29 AC).

const PERIOD_RE = /^(\d{4})-(0[1-9]|1[0-2])$/;

export interface CategoriesSearch {
  readonly period: string | undefined;
  readonly selected: string | undefined;
}

function nonEmptyString(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : undefined;
}

export function parseCategoriesSearch(input: Record<string, unknown>): CategoriesSearch {
  const period =
    typeof input.period === 'string' && PERIOD_RE.test(input.period) ? input.period : undefined;
  return {
    period,
    selected: nonEmptyString(input.selected),
  };
}
